import Reveal from "@/components/Reveal";
import StoreCard from "@/components/StoreCard";

export default function Stores({ stores, t }) {
  return (
    <section id="negozi" data-testid="stores-section" className="py-20 sm:py-28 lg:py-32 bg-[#F3ECE0] border-y border-[#241C1A]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
              {t.stores.over}
            </p>
            <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#241C1A] leading-[1.1]">
              {t.stores.title}
            </h2>
          </div>
          <p className="text-base text-[#6E625E] max-w-sm leading-relaxed">
            {t.stores.sub}
          </p>
        </Reveal>

        <div className="mt-14 sm:mt-20 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-8">
          {stores.map((store, i) => (
            <Reveal key={store.id} delay={i * 0.12}>
              <StoreCard store={store} t={t} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
